import React from "react";
import { PatternFormat, type PatternFormatProps } from "react-number-format";
import TextField, { type TextFieldProps } from "../TextField";

export type MaskedTextFieldProps = PatternFormatProps & TextFieldProps;

const MaskedTextField = ({
  onChange,
  format,
  ...props
}: MaskedTextFieldProps) => {
  return (
    <PatternFormat
      {...props}
      onChange={onChange}
      format={format}
      customInput={TextField}
    />
  );
};

export default MaskedTextField;
